export enum FavoriteType {
    Product = 'Product',
    Brand = 'Brand',
    Location = 'Location',
}
